<script>
// import Swiper JS
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination } from "swiper/core";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination]);
export default {
  name: "estamos-da-midia",
  data() {
    return {};
  },
  mounted() {
    var swiper = new Swiper(this.$refs["mySwiper7"], {
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
      },
      pagination: {
        el: this.$refs["swiper-pagination"],
        clickable: true,
      },
      navigation: {
        nextEl: this.$refs["swiper-button-next7"],
        prevEl: this.$refs["swiper-button-prev7"],
      },
    });
    var swiper2 = new Swiper(this.$refs["mySwiper8"], {
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
      },
      pagination: {
        el: this.$refs["swiper-pagination"],
        clickable: true,
      },
      navigation: {
        nextEl: this.$refs["swiper-button-next8"],
        prevEl: this.$refs["swiper-button-prev8"],
      },
    });
  },
  components: {},
  computed: {
    ourAreas() {
      return this.$store.state.ourAreas;
    },
  },
};
</script>

<template>
  <section class="midia" id="midia">
    <header>
      <div class="container">
        <h1 class="title">ESTAMOS NA MÍDIA</h1>
      </div>
    </header>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="box">
            <h2>
              Grupo Travelex
              <div class="break d-none d-md-block"></div>
              na mídia
            </h2>

            <div class="swiper-container mySwiper" ref="mySwiper7">
              <div class="swiper-wrapper">

                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img">
                      <img
                        src="@/views/home/assets/images/midia/linkedin.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>
                        Travelex Bank patrocina a Rila 2023 - Rota da Integração Latino Americana
                      </p>
                      <a
                        href="https://www.linkedin.com/posts/grupo-travelex-confidence_megaestrada-que-vai-ligar-o-brasil-ao-chile-activity-7133038955259645952-XrUv?utm_source=share&utm_medium=member_desktop"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img">
                      <img
                        src="@/views/home/assets/images/midia/linkedin.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>
                        Travelex Bank é classificado com excelência pela Fitch Ratings.
                      </p>
                      <a
                        href="https://www.linkedin.com/posts/grupo-travelex-confidence_fitchratings-bancodecambio-travelexbank-activity-7123284069089431552-Aw1z?utm_source=share&utm_medium=member_desktop"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>
                
                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img">
                      <img
                        src="@/views/home/assets/images/midia/logo-viajar-simples.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>
                        Travelex Confidence oferece transferências para o Brasil
                        com tarifa zero neste mês
                      </p>
                      <a
                        href="https://viajaresimples.com.br/news/travelex-confidence-transferenci/"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img">
                      <img
                        src="@/views/home/assets/images/midia/Estadão-logo.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>Real conversível e digital? O que podemos esperar.</p>
                      <a
                        href="https://politica.estadao.com.br/blogs/fausto-macedo/real-conversivel-e-digital-o-que-podemos-esperar/"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img">
                      <img
                        src="@/views/home/assets/images/midia/baguete.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>Travelex Confidence adota omnichannel TIM.</p>
                      <a
                        href="https://www.baguete.com.br/noticias/26/07/2021/travelex-confidence-adota-omnichannel-tim"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img">
                      <img
                        src="@/views/home/assets/images/midia/investing.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>
                        BC "mais tempestivo" tenta frear aposta em selic
                        restritiva demais Por Reaters.
                      </p>
                      <a
                        href="https://br.investing.com/news/economic-indicators/bc-mais-tempestivo-tenta-frear-aposta-em-selic-restritiva-demais-901470"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev" ref="swiper-button-prev7"></div>
              <div class="swiper-button-next" ref="swiper-button-next7"></div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="box">
            <h2>
              A visão dos nossos
              <div class="break d-none d-md-block"></div>
              Executivos
            </h2>

            <div class="swiper-container mySwiper" ref="mySwiper8">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img img-executives">
                      <img
                        src="@/views/home/assets/images/midia/christian.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>
                        <strong>Palavras de um desafio global,</strong> por Christian Stier, CFO do Travelex Bank
                      </p>
                      <a
                        href="https://www.travelexbank.com.br/blog/palavras-de-um-desafio-global/"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img img-executives">
                      <img
                        src="@/views/home/assets/images/midia/christian-2.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p><strong>Pix revolucionará transações em moeda estrangeira,</strong> por João Manuel Campanelli, COO do Travelex Bank</p>
                      <a
                        href="https://www.travelexbank.com.br/blog/pix-revolucionara-transacoes-em-moeda-estrangeira-2/"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="img-text">
                    <div class="img img-executives">
                      <img
                        src="@/views/home/assets/images/midia/christian-1.png"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>Real conversível e digital?, por João Manuel Campanelli Freitas, COO do Travelex Bank</p>
                      <a
                        href="https://www.travelexbank.com.br/blog/real-conversivel-e-digital-o-que-podemos-esperar/"
                        target="_blank"
                        class="btn btn-cyan-ml"
                        >Leia mais</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev" ref="swiper-button-prev8"></div>
              <div class="swiper-button-next" ref="swiper-button-next8"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="equipe">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="equipe__box">
              <div class="equipe__img">
                <img
                  class="gptw"
                  src="@/views/home/assets/images/midia/GPTW.png" 
                  alt=""
                />
              </div>
              <div class="equipe__img">
                <img
                  src="@/views/home/assets/images/midia/selo-abracam.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h3>
              Quer fazer parte da
              <div class="break"></div>
              nossa equipe?
            </h3>
            <p>Cadastre-se clicando no botão abaixo.</p>
            <router-link to="/deixe-seu-perfil" class="btn btn-secondary"
              >Cadastre seu currículo</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.midia {
  .who-we-are__combined {
    position: relative;
    z-index: 999;
  }
  padding-bottom: 3rem;
  .mySwiper {
    position: initial !important;
  }
  position: relative;
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 1rem;
    display: none;
  }
  .swiper-pagination-bullet-active {
    background: #000 !important;
  }
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 20px;
    height: 20px;
    padding: 18px !important;
    border: 2px solid #212644;
    border-radius: 50%;
    top: auto;
    bottom: 2rem;
    @include media-breakpoint-down(md) {
      bottom: 1rem;
    }
    left: 0 !important;
    right: 0 !important;
    margin: 0 auto;
  }

  .swiper-button-prev {
    transform: translateX(-25px);
  }

  .swiper-button-next {
    transform: translateX(25px);
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 1.3rem;
    color: #000;
  }
}
</style>

<style lang="scss" scoped>
header {
  background-color: #fff;
  height: calc(100px + 2rem);
  padding-top: 2rem;
}
.row {
  margin-top: -70px;
}
h2 {
  font-size: 2rem !important;
  color: #212644;
  @include media-breakpoint-down(md) {
    font-size: 1.3rem !important;
  }
}
p {
  font-size: 0.9rem;
  line-height: calc(0.9rem * 1.5);
  margin-left: 0.5rem;
  min-height: 60px;
}
h4 {
  font-size: 1.3rem !important;
  @include media-breakpoint-down(md) {
    font-size: 1.3rem !important;
  }
}
.box {
  box-shadow: 0px 5px 16px #00000029;
  border-radius: 7px;
  padding: 4rem 3rem 6rem 3rem;
  position: relative;
  margin-top: 3rem;
  background-color: #fff;
  button,
  a {
    background: #48b2eb 0% 0% no-repeat padding-box;
    border-radius: 6px !important;
    color: #fff;
    padding: 0.5rem 2.5rem;
    margin: 0 auto;
    display: block;
    &:hover {
      background-color: lighten(#48b2eb, 9);
      border-color: lighten(#48b2eb, 9);
    }
  }
  @include media-breakpoint-down(md) {
    padding: 2rem 2rem 4rem 2rem;
  }
  .img-text {
    margin-top: 2rem;
    .text {
      p {
        min-height: 60px;
        line-height: 1.4rem;
      }
    }
    @include media-breakpoint-down(md) {
      margin-top: 1rem;
        .text {
      p {
        min-height: auto;
      }
    }
    }
    margin: 1rem 1rem 1rem 0.3rem;
    .img {
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 2px 2px 6px #00000029;
      border-radius: 7px;
      margin-bottom: 1rem;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
  }
  img {
    width: 140px;
  }
  .img-executives {
    img {
      width: 110%;
      max-width: 110%;
    }
  }
  .video {
    height: 220px;
    border-radius: 4px;
    background-color: rgb(89, 95, 97);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1.25rem 0px;
    @include media-breakpoint-down(md) {
      height: 150px;
    }
    img {
      width: 50px;
      cursor: pointer;
    }
  }
}

.equipe {
  background-color: #fff;
  margin-top: 4rem;
  padding: 4rem 0px 4rem 0px;
  margin-bottom: -3rem;
  h3 {
    color: #5d646c !important;
    font-family: "Lato", sans-serif;
    font-size: 3rem !important;
  }
  p {
    font-size: 1.4rem;
    margin-top: 1rem;
  }
  @include media-breakpoint-down(md) {
    h3 {
      font-size: 1.7rem !important;
      margin-top: 2rem;
    }
    p {
      font-size: 1rem;
      margin: 0px;
      margin-top: 1rem;
    }
  }
  .row,
  .container {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  button,
  a {
    background-color: theme-color(secondary);
    border-radius: 6px !important;
    color: #fff;
    padding: 0.8rem 0px;
    width: 100%;
    max-width: 400px;
    font-size: 1.4rem;
    font-weight: 400;
    font-family: "Lato", sans-serif;
    @include media-breakpoint-down(md) {
      font-size: 1.1rem;
      margin-top: -1rem;
    }
    &:hover {
      background-color: lighten(theme-color("secondary"), 9);
    }
  }
  &__box {
    display: flex;
  }
  &__img {
    width: 250px;

    .gptw{
       width: 70%;
       margin-top: -2px;
    }
    img {
      width: 100%;
    }
    &:last-child {
      width: 150px;
      margin-left: -1.5rem;
    }
    @include media-breakpoint-down(md) {
      width: 150px;
      margin-left: -2.5rem;
      .gptw{
       margin-left: 25px;
      }

      img {
        width: 100%;
      }
      &:last-child {
        width: 80px;
        margin-left: -1.5rem;
      }
    }
  }
}
</style>

